import styled from "styled-components";
import { breakpoints } from "../../globalStyles";
import { modalState } from "../../utils/constants";

export const Overlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ $zIndex }) => $zIndex};
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
`;

export const Modal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ $zIndex }) => $zIndex};
`;

export const ModalContent = styled.div`
  padding: 24px 36px;
  background-color: var(--card-hover);
  border-radius: 8px;
  max-width: 480px;
  width: 100%;

  @media (max-width: 428px) {
    padding: 24px;
    max-width: 328px;
  }
`;

export const ModalBox = styled.div`
  position: absolute;

  color: rgba(255, 255, 255, 0.9);
  width: 100%;
  max-width: 590px;
  padding: 10px;

  @media ${breakpoints.sm} and (orientation: landscape) {
    top: 22%;
  }
  @media ${breakpoints.xs} {
    top: ${(props) =>
      props.openMobileModal === modalState.EDIT_DATA ||
      props.openMobileModal === modalState.EDIT_EMAIL
        ? "10%"
        : "none"};
    height: ${(props) =>
      props.openMobileModal === modalState.EDIT_DATA
        ? "calc(100vh - 10%)"
        : "none"};
  }
  @media ${breakpoints.xs} and (orientation: landscape) {
    top: 28%;
    height: ${(props) =>
      props.openMobileModal === modalState.EDIT_DATA ||
      props.openMobileModal === modalState.EDIT_EMAIL
        ? "calc(100vh - 28%)"
        : "none"};
  }
  @media (max-width: 390px) {
    top: 10%;
  }
`;

export const ModalInner = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const ModalTitle = styled.h2`
  font-family: "Inter";
  font-weight: 900;
  font-size: 40px;
  line-height: 120%;

  text-align: center;
  letter-spacing: 1px;

  @media ${breakpoints.sm} {
    font-size: 32px;
  }
  @media ${breakpoints.xs} {
    font-size: 28px;
  }
`;

export const ModalDesc = styled.div`
  margin-top: 8px;
  text-align: center;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;

  @media ${breakpoints.sm} {
    font-size: 16px;
  }
`;
export const DescHighlight = styled.span`
  color: #d75b3c;
`;

export const ModalForm = styled.form`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ModalFormBtnDoneInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
`;
export const ModalFormDone = styled.div`
  padding: 22px 12px;

  background: transparent;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  text-transform: uppercase;
`;

export const ModalFormBtnSecond = styled.button`
  padding: 22px 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 140%;
  text-align: ${(props) => (props.editPersonalData ? "left" : "center")};
  text-transform: uppercase;
  transition: color 50ms ease-out;
  &:hover {
    color: #ed6c45;
  }
  &:active {
    color: #d4603d;
  }
  &:disabled {
    opacity: 0.3;
  }
  @media ${breakpoints.sm} {
    font-size: 16px;
    padding: 21px 0px;
  }
`;

export const ErrorAlert = styled.div`
  margin-top: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #ff3737;
`;

export const IconCheckBigInner = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px auto 0;
`;

export const LogForgetPassword = styled.div`
  margin-top: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #d75b3c;
  cursor: pointer;
`;

export const EditDataComplete = styled.div`
  margin-top: 24px;
  padding: 22px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  text-transform: uppercase;
  & svg {
    width: 32px;
    height: 32px;
  }
`;
export const EditDataCompleteText = styled.div`
  margin-left: 12px;
  background: transparent;
`;
